(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hnj-home-light"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mobile = window.matchMedia('(max-width:749px)');
  const reconcile = () => {
    document.querySelectorAll('[data-hnj-duplicate-policy]').forEach(el => el.removeAttribute('data-hnj-duplicate-policy'));
    document.querySelectorAll('[data-hnj-empty-policies]').forEach(el => el.removeAttribute('data-hnj-empty-policies'));
    if (!mobile.matches || !document.querySelector('.hnj-home') || !('showPopover' in HTMLElement.prototype)) return;
    const triggers = document.querySelectorAll('.footer-utilities .policy-list-trigger[popovertarget]');
    const destinations = new Set();
    triggers.forEach(trigger => {
      const popup = document.getElementById(trigger.getAttribute('popovertarget'));
      if (!popup || !popup.hasAttribute('popover') || trigger.disabled) return;
      popup.querySelectorAll('a[href]').forEach(link => {
        const raw = link.getAttribute('href');
        if (raw && !raw.startsWith('#') && /^https?:/.test(link.href)) destinations.add(link.href);
      });
    });
    if (!destinations.size) return;
    document.querySelectorAll('.hnj-footer-finish__policies').forEach(nav => {
      nav.querySelectorAll('a[href]').forEach(link => {
        if (destinations.has(link.href)) link.setAttribute('data-hnj-duplicate-policy','');
      });
      const controls = [...nav.querySelectorAll('a,button')];
      if (controls.length && controls.every(el => el.hasAttribute('data-hnj-duplicate-policy'))) nav.setAttribute('data-hnj-empty-policies','');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile, {once:true});
  else reconcile();
  mobile.addEventListener('change', reconcile);
  document.addEventListener('shopify:section:load', reconcile);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(reconcile));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
